import React from 'react';
import cn from 'classnames';
import { createClassRedirect } from 'legacy-src/utility/utils';
import './styles.scss';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';

const Container = ({ message, children, className = '' }) => (
  <div
    aria-label={message}
    className={cn('NoClassesAlert--container', className)}
  >
    {children || message}
  </div>
);

export const TeacherNoClassesAlert = (props) => {
  const {
    subject: { id },
    router,
  } = props;

  const onClick = () => {
    createClassRedirect(id, router);
  };

  return (
    <Container message="Create a class section and enroll students to see which students have watched this video.">
      <AccessibilityWrapper>
        <a onClick={onClick} role="link" tabIndex="0">
          Create a class section
        </a>
      </AccessibilityWrapper>{' '}
      and enroll students to see which students have watched this video.
    </Container>
  );
};

export const AdminCoordNoSchoolsAlert = () => (
  <Container message="No class sections have been created. Create a class section and enroll students to see which students have watched this video." />
);

export const AdminCoordNoSchoolClassesAlert = () => (
  <Container message="No class sections have been created at this school. Create a class section and enroll students to see which students have watched this video." />
);

export const NoStudentsAlert = ({ className = '' }) => (
  <Container
    className={className}
    message="No students are currently enrolled in this class section."
  />
);
